// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css';
import {api_prefix} from "../config/api_url";

Vue.prototype.$axios = axios
//修改vue的原始属性
// axios.defaults.baseURL = '/api-xm/'
axios.defaults.headers.post['Content-Type'] = 'application/json';
// 挂载到原型对象之前 先设置拦截器 通过axios请求拦截器添加token，保证拥有获取数据的权限
axios.interceptors.request.use(config => {
    //在 request 拦截器中， 展示进度条 NProgress.start()
    NProgress.start()
    // 为请求头对象添加Token验证的Authorization字段
    // config.headers.Authorization = window.sessionStorage.getItem('token')
    // 最后都必须 return config
    return config
})
// 在 response 拦截器中， 隐藏进度条 NProgress.done()
axios.interceptors.response.use(config => {
    NProgress.done()
    return config
})

router.beforeEach((to, from, next) => {
    if (to.path === '/login') {
        console.log(to.path)
        next();
    } else {
        let token = localStorage.getItem('token');//token保存在localstorage中
        if (token === null || token === '') {
            next('/login');
        } else {
            axios({
                method:"post",
                url: api_prefix() + "/user/check-login",
                headers: {
                    'token': token,
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then (response => {
                let res = response.data
                console.log(res)
                if (res.code !== 200) {
                    next('/login');
                }
            })
            next();
        }
    }
});

//修改vue的原始属性
Vue.prototype.$axios = axios

Vue.config.productionTip = false
Vue.use(ElementUI);

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js